export default {
  api: {
    baseUrl: 'https://api.x.wappin.app',
    chatUrl: 'https://api.chat.wappin.app',
  },
};
